import { ONE_TRUST_CONSENT_GROUP } from '../lib/config.js';

/** 9/14/25 New function to fire events for paid media optimization
 * Only fires if we can find proper cookies consent.
 */
export const fireConversionEvents = () => {
  // 1. Check for OneTrust cookie consent for "Targeting Cookies".
  const hasConsent = window.OnetrustActiveGroups && window.OnetrustActiveGroups.includes(ONE_TRUST_CONSENT_GROUP); // Do nothing if we can't find it
  if (!hasConsent) {
    console.log('No tracking');
    return;
  }
  // 2. Fire events for each platform.
    // -- Google Ads --
  try {
    // Check if gtag function exists (it's loaded by the main Google Analytics or Ads script)
    if (typeof gtag === 'function') {
      gtag('event', 'conversion', {
          'send_to': 'AW-808791726/NjGACIHb-pwaEK7d1IED',
          'value': 1.0,
          'currency': 'USD'
      });
      console.log("Google Ads lead event fired.");
    } else {
      console.warn("Google Ads gtag function not found. Lead event not fired.");
    }
  } catch(error) {
    console.error("Error firing Google Ads lead event:", error);
  }
  // -- Facebook --
  try {
    // Fire the base code if it does not exist (will skip if found)
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    
    // Initialize the pixel if it hasn't been already
    window.fbq('init', '1568087270153240');
    
    // Fire the standard Lead event
    window.fbq('track', 'Lead');
    console.log("Facebook Pixel event: Lead fired.");
  } catch (error) {
    console.error("Error firing Facebook pixel:", error);
  }

  // -- TikTok --
  try {
    !function (w, d, t) {
      w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var r="https://analytics.tiktok.com/i18n/pixel/events.js",o=n&&n.partner;ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=r,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};var a=document.createElement("script");a.type="text/javascript",a.async=!0,a.src=r+"?sdkid="+e+"&lib="+t;var i=document.getElementsByTagName("script")[0];i.parentNode.insertBefore(a,i)};
      ttq.load('D33KGHJC77U7TGIRDV6G');
      ttq.page();
    }(window, document, 'ttq');
    window.ttq.track('CompleteRegistration', {});
    console.log("Form submit - tiktok");
  } catch (error) {
    console.error("Error firing TikTok pixel:", error);
  }

  // -- Reddit --
  try {
    !function(w,d){if(!w.rdt){var p=w.rdt=function(){p.sendEvent?p.sendEvent.apply(p,arguments):p.callQueue.push(arguments)};p.callQueue=[];var t=d.createElement("script");t.src="https://www.redditstatic.com/ads/pixel.js",t.async=!0;var s=d.getElementsByTagName("script")[0];s.parentNode.insertBefore(t,s)}}(window,document);
    window.rdt('init','t2_17cv3mpk');
    window.rdt('track', 'SignUp');
    console.log("Reddit Pixel event: SignUp fired.");
  } catch(error) {
    console.error("Error firing Reddit pixel:", error);
  }

  // -- Twitter/X --
    try {
    !function(e,t,n,s,u,a){e.twq||(s=e.twq=function(){s.exe?s.exe.apply(s,arguments):s.queue.push(arguments);
    },s.version='1.1',s.queue=[],u=t.createElement(n),u.async=!0,u.src='https://static.ads-twitter.com/uwt.js',
    a=t.getElementsByTagName(n)[0],a.parentNode.insertBefore(u,a))}(window,document,'script');

    window.twq('config','o37dn');
    window.twq('event', 'tw-o37dn-qs96j', {});
    console.log("Form submit X");
  } catch (error) {
    console.error("Error firing Twitter pixel:", error);
  }

  try {
    !function(e,t,n,s,u,a){e.twq||(s=e.twq=function(){s.exe?s.exe.apply(s,arguments):s.queue.push(arguments);
    },s.version='1.1',s.queue=[],u=t.createElement(n),u.async=!0,u.src='https://static.ads-twitter.com/uwt.js',
    a=t.getElementsByTagName(n)[0],a.parentNode.insertBefore(u,a))}(window,document,'script');

    window.twq('config','o8eyt');
    window.twq('event', 'tw-o8eyt-qho87', {});
    console.log("Form submit X");
  } catch (error) {
    console.error("Error firing Twitter pixel:", error);
  }

  // -- Floodlight --
  try {
    const axel = Math.random() + "";
    const ord = axel * 10000000000000000; // cache-busting
    const floodlightFrame = document.createElement('iframe');

    // Hotline specific floodlight ID
    floodlightFrame.src = `https://9170879.fls.doubleclick.net/activityi;src=9170879;type=gs001;cat=getse00;ord=${ord}?`;

    // Set attributes to ensure it's not visible
    floodlightFrame.width = 1;
    floodlightFrame.height = 1;
    floodlightFrame.style.display = 'none';

    // Append the iframe to the body to fire the tag
    document.body.appendChild(floodlightFrame);

    console.log("Form submit DV360");
  } catch (error) {
    console.error("Error firing Floodlight tag:", error);
  }
};
